import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
gsap.registerPlugin(MotionPathPlugin);

import Lenis from 'lenis'

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    if(!this.pack.hasTouch){
      this.lenis = new Lenis({
        autoRaf: true,
        // duration: 0.4,
      });
      this.lenis.stop();
    }

    this.setCopyrightYear();

    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  reset() {
    super.reset();

    this.setVars();
    this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    this.pack.common.removeScrollTarget(this);
    this.pack.common.removeEnterframeTarget(this);
  }

  setVars() {
    super.setVars();

    this.BASE_W_PC = 1440;
    this.BASE_W_SP = 400;

    this.MASK_W_PC = 720;
    this.MASK_H_PC = 304;

    this.MASK_W_SP = 362;

    this.isAtBottom = false; // 最下部到達フラグ

    this.kvCurrent = 0;
    this.kvPast = 0;
    this.KV_LEN = 2;
    this.sectionAttentioned = [];
    this.section1LiAttentioned = [];
    this.section2ProductNameAttentioned = [];
    this.section3PersonNameAttentioned = [];

    this.section2ImgsDefValue = [{x:2, scale:1.35}, {x:0, scale:1.35}];
  }

  setDom() {
    super.setDom();

    this.headerH2 = document.querySelector('header h2');
    this.navDom = document.querySelector('.nav');
    this.navBtnDom = document.querySelectorAll('.nav ul li .wrap');
    this.svgGroup = document.querySelector('.needs_transform');
    this.heroDom = document.querySelector('main.top .hero');
    this.heroH1Dom = document.querySelector('main.top .hero h1');
    this.heroImgs = document.querySelector('main.top .hero .imgs');
    this.heroMaskContainer = document.querySelector('main.top .hero .mask_container');
    this.heroDuplicate = document.querySelector('main.top .hero_duplicate');

    this.sections = document.querySelectorAll('main.top .section');

    this.section1Lis = document.querySelectorAll('main.top .section1 .patisseries li');
    this.section1Imgs = document.querySelectorAll('main.top .section1 .patisseries li .img img');

    this.section2Imgs = document.querySelectorAll('main.top .section2 .boxes li .img > img');
    this.section2ProductNames = document.querySelectorAll('main.top .section2 .boxes li .product_name');
    this.section3PersonNames = document.querySelectorAll('main.top .section3 .people li .person_name');

    this.kvCpYear = document.querySelector('main.top .hero .cp .year');
    this.footerCp = document.querySelector('footer .cp');
    this.footerCpYear = document.querySelector('footer .cp .year');
    this.setSectionAttentioned();
  }

  setCopyrightYear() {
    const currentYear = new Date().getFullYear();

    this.kvCpYear.textContent = currentYear;
    this.footerCpYear.textContent = currentYear;
  }

  setDomDelay(){
    this.heroImgsItems = document.querySelectorAll('main.top .hero .imgs img');
    this.heroMaskItems = document.querySelectorAll('main.top .hero .mask_container img');
    this.heroIllustItems = document.querySelectorAll('main.top .hero .illust_container .illust');
    // this.heroDuplicateImgsItems = document.querySelectorAll('main.top .hero_duplicate .imgs img');
    // this.heroDuplicateMaskItems = document.querySelectorAll('main.top .hero_duplicate .mask_container img');
    // this.heroDuplicateIllustItems = document.querySelectorAll('main.top .hero_duplicate .illust_container .illust');

    this.heroCurrentUICurrent = document.querySelector('main.top .hero .current_ui .current');
    this.heroCurrentUITotal = document.querySelector('main.top .hero .current_ui .total');
    // this.heroDuplicateCurrentUICurrent = document.querySelector('main.top .hero_duplicate .current_ui .current');
    // this.heroDuplicateCurrentUITotal = document.querySelector('main.top .hero_duplicate .current_ui .current');

    // this.heroCurrentUITotal.innerText = this.heroDuplicateCurrentUITotal.innerText = this.heroImgsItems.length;
    this.heroCurrentUITotal.innerText = this.heroImgsItems.length;

    for( let i = 0, len = this.heroIllustItems.length; i < len; i++ ){
      let illust = this.heroIllustItems[i];
      // let illust2 = this.heroDuplicateIllustItems[i];
      illust.classList.add('has_transition');
      // illust2.classList.add('has_transition');
    }
  }

  initEvents() {
    super.initEvents();

    for( let i = 0, len = this.navBtnDom.length; i < len; i++ ){
      let btn = this.navBtnDom[i];
      let id = i;
      btn.addEventListener('click', () => {
        this.pack.anchorScroll(this.sections[id].offsetTop);
      });

      btn.addEventListener('mouseover', () => {
        if(this.pack.hasTouch) return;
        let items = btn.querySelectorAll('.item');
        let len2 = items.length;
        for( let j = 0; j < len2; j++ ){
          let item = items[j];
          let rotation = 30 + Math.random() * 30;
          if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
          let delay = j * .02 + Math.random() * .02;
          this.commonTextMotion(item, delay, rotation);
        }
      });
    }
  }

  setSectionAttentioned(){
    for( let i = 0, len = this.sections.length; i < len; i++ ){
      this.sectionAttentioned[i] = false;
    }

    for( let i = 0, len = this.section1Lis.length; i < len; i++ ){
      this.section1LiAttentioned[i] = false;
    }

    for( let i = 0, len = this.section2ProductNames.length; i < len; i++ ){
      this.section2ProductNameAttentioned[i] = false;
    }

    for( let i = 0, len = this.section3PersonNames.length; i < len; i++ ){
      this.section3PersonNameAttentioned[i] = false;
    }
  }

  start() {
    this.duplicateHero();
    this.setDomDelay();
    this.heroDuplicate.style.opacity = 0;
    this.heroDom.classList.add('start');
    // this.heroDuplicate.classList.add('start');
    gsap.delayedCall(.8, ()=>{
      window.scrollTo(0, 0);
      this.heroMaskItems[this.kvCurrent].classList.add('show');
      // this.heroDuplicateMaskItems[this.kvCurrent].classList.add('show');
      this.heroDom.classList.add('start2');
      // this.heroDuplicate.classList.add('start2');
      gsap.delayedCall(0.7, ()=>{
        this.heroDom.classList.add('start3');
        // this.heroDuplicate.classList.add('start3');
        this.heroImgsItems[this.kvCurrent].classList.add('show');
        // this.heroDuplicateImgsItems[this.kvCurrent].classList.add('show');
        gsap.delayedCall(0.9, ()=>{
          this.heroDom.classList.add('start4');
          // this.heroDuplicate.classList.add('start4');
          this.heroIllustItems[this.kvCurrent].classList.add('show');
          // this.heroDuplicateIllustItems[this.kvCurrent].classList.add('show');
          this.navDom.classList.add('start');
          if(this.lenis) this.lenis.start();
          this.intervalId = setInterval(this.intervalFunc.bind(this), 4000);

          this.startNavAnimation();
        });
      });
    });
  }

  startNavAnimation() {
    for( let i = 0, len = this.navBtnDom.length; i < len; i++ ){
      let btn = this.navBtnDom[i];
      let items = btn.querySelectorAll('.item');
      let len2 = items.length;
      for( let j = 0; j < len2; j++ ){
        let item = items[j];
        let rotation = 30 + Math.random() * 30;
        if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
        let delay = j * .02 + Math.random() * .02;
        this.commonTextMotion(item, delay, rotation);
      }
    }
  }

  commonTextMotion(item, delay, rotation, y){
    y = y || '-0.45rem';
    gsap.to(item, {
      duration: 0.63,
      ease:'cubic.out',
      delay: delay,
      motionPath:[
        {rotation:rotation, y: y},
        {rotation:0, y: 0}
      ]
    });
  }


  intervalFunc(){
    if(this.kvCurrent === this.KV_LEN - 1) this.kvCurrent = 0;
    else this.kvCurrent++;

    // this.heroCurrentUICurrent.innerText = this.heroDuplicateCurrentUICurrent.innerText = this.kvCurrent + 1;
    this.heroCurrentUICurrent.innerText = this.kvCurrent + 1;
    let rotation = 30 + Math.random() * 30;
    if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
    this.commonTextMotion(this.heroCurrentUICurrent, 0, rotation, '-0.25rem');
    // this.commonTextMotion(this.heroDuplicateCurrentUICurrent, 0, rotation, '-0.25rem');

    this.heroImgsItems[this.kvPast].classList.remove('show');
    this.heroMaskItems[this.kvPast].classList.remove('show');
    this.heroIllustItems[this.kvPast].classList.remove('show');
    // this.heroDuplicateImgsItems[this.kvPast].classList.remove('show');
    // this.heroDuplicateMaskItems[this.kvPast].classList.remove('show');
    // this.heroDuplicateIllustItems[this.kvPast].classList.remove('show');

    this.heroImgsItems[this.kvCurrent].classList.add('show');
    this.heroMaskItems[this.kvCurrent].classList.add('show');
    this.heroIllustItems[this.kvCurrent].classList.add('show');
    // this.heroDuplicateImgsItems[this.kvCurrent].classList.add('show');
    // this.heroDuplicateMaskItems[this.kvCurrent].classList.add('show');
    // this.heroDuplicateIllustItems[this.kvCurrent].classList.add('show');

    this.kvPast = this.kvCurrent;
  }

  duplicateHero() {
    this.heroDuplicate.innerHTML = this.heroDom.innerHTML;
  }

  getProgress(currentValue, min, max){
    // ゼロ除算を避けるためのチェック
    if (max - min === 0) {
      return currentValue <= min ? 1 : 0;
    }

    // (max - currentValue) で、値が減少するほど進行度が上がるようにする
    const progress = (max - currentValue) / (max - min);

    // Math.maxとMath.minを使って、結果を確実に0〜1の範囲に収める
    return Math.max(0, Math.min(1, progress));
  }

  mapValue(progress, min, max) {
    return min + (max - min) * progress;
  }

  scrollHero(){
    let scrollY = this.pack.scrollY;
    let per = Math.min(scrollY / this.sh, 1);
    let y = this.shh * per;
    if(y >= this.shh) y = 0;
    this.heroImgs.style.transform = `translate3d(0, ${y}px, 0)`;
    this.heroMaskContainer.style.transform = `translate3d(0, ${y}px, 0)`;
    this.heroH1Dom.style.transform = `translate3d(0, ${y}px, 0)`;
  }

  //Patisserie
  scrollSection1(){
    for( let i = 0, len = this.section1Lis.length; i < len; i++ ){
      //画像視差効果
      let item = this.section1Lis[i];
      let img = this.section1Imgs[i];
      let currentY = item.getBoundingClientRect().top;
      let minY = -item.clientHeight;
      let maxY = this.sh;
      let progress = this.getProgress(currentY, minY, maxY);
      let per = this.mapValue(progress, -65, -35);
      img.style.transform = `translate3d(-50%, ${per}%, 0)`;

      if(!this.section1LiAttentioned[i]){
        //説明文
        if(currentY <= this.shh){
          this.section1LiAttentioned[i] = true;
          let items = item.querySelectorAll('.item');
          let len2 = items.length;
          for( let j = 0; j < len2; j++ ){
            let itm = items[j];
            let rotation = 30 + Math.random() * 30;
            if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
            let delay = j * .007 + Math.random() * .02;
            this.commonTextMotion(itm, delay, rotation);
          }
        }
      }
    }
  }

  //Box
  scrollSection2(){
    for( let i = 0, len = this.section2Imgs.length; i < len; i++ ){
      let img = this.section2Imgs[i];
      let currentY = img.getBoundingClientRect().top;
      let minY = -img.clientHeight;
      let maxY = this.sh;
      let progress = this.getProgress(currentY, minY, maxY);
      let per = this.mapValue(progress, 0, 17);
      let scale = this.section2ImgsDefValue[i].scale;
      let x = this.section2ImgsDefValue[i].x;
      img.style.transform = `scale(${scale}) translate3d(${x}rem, ${per}%, 0)`;

      if(!this.section2ProductNameAttentioned[i]){
        let names = this.section2ProductNames[i];
        let top = names.getBoundingClientRect().top;
        if(top <= this.sh - (this.shh * .5)){
          this.section2ProductNameAttentioned[i] = true;
          let items = names.querySelectorAll('.item');
          let len2 = items.length;

          for( let j = 0; j < len2; j++ ){
            let item = items[j];
            let rotation = 30 + Math.random() * 30;
            if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
            let delay = j * .03 + Math.random() * .02;
            this.commonTextMotion(item, delay, rotation);
          }
        }
      }
    }
  }

  //About
  scrollSection3(){
    for( let i = 0, len = this.section3PersonNames.length; i < len; i++ ){
      if(!this.section3PersonNameAttentioned[i]) {
        let names = this.section3PersonNames[i];
        let top = names.getBoundingClientRect().top;
        if(top <= this.sh - (this.shh * .5)){
          this.section3PersonNameAttentioned[i] = true;
          let items = names.querySelectorAll('.item');
          let len2 = items.length;

          for (let j = 0; j < len2; j++) {
            let item = items[j];
            let rotation = 30 + Math.random() * 30;
            if (Math.floor(Math.random() * 2) === 0) rotation *= -1;
            let delay = j * .02 + Math.random() * .03;
            this.commonTextMotion(item, delay, rotation);
          }
        }
      }
    }
  }

  checkPageBottom() {
    if(this.pack.hasTouch) return;

    //ページ最下部判定
    const scrollY = this.pack.scrollY;
    const windowHeight = this.sh; // this.sh はウィンドウの高さですね
    const pageHeight = document.documentElement.scrollHeight;

    // 1px程度の誤差を許容する
    if (scrollY + windowHeight >= pageHeight - 2) {
      if (!this.isAtBottom) {
        this.isAtBottom = true;
        if(this.lenis) this.lenis.stop();
        window.scrollTo(0, 0);
        this.setSectionAttentioned();
      }
    } else {
      if(this.isAtBottom){
        if(this.lenis) this.lenis.start();
      }
      this.isAtBottom = false;
    }
  }

  check2NDView() {
    const scrollY = this.pack.scrollY;
    if(scrollY >= this.sh){
      if(!this.headerH2.classList.contains('has_transition')) this.headerH2.classList.add('has_transition');

      let footerTop = this.footerCp.getBoundingClientRect().top;
      let section3Top = this.sections[2].getBoundingClientRect().top;
      if(section3Top < this.shh * .5) {
        if(this.headerH2.classList.contains('show')) this.headerH2.classList.remove('show');
      }else{
        if(!this.headerH2.classList.contains('show')) this.headerH2.classList.add('show');
      }

      if(footerTop < -this.footerCp.clientHeight){
        if (!this.isAtBottom) {
          this.isAtBottom = true;
          if(this.lenis) this.lenis.stop();
          this.navDom.classList.remove('start');
          window.scrollTo(0, 0);
          document.body.style.position = 'fixed';
          this.setSectionAttentioned();
          let mainDom = document.querySelector('main.top');
          gsap.fromTo(mainDom, 1, {opacity: 0}, {opacity: 1, ease:'quad.out', onComplete:()=>{
              document.body.style.position = 'inherit';
              if(this.isAtBottom){
                if(this.lenis) this.lenis.start();
                this.navDom.classList.add('start');
              }
              this.isAtBottom = false;
            }});
        }
      }
    }else{
      if(this.headerH2.classList.contains('show')) this.headerH2.classList.remove('show');
    }
  }

  scrollSections(){
    for( let i = 0, len = this.sections.length; i < len; i++ ){
      let section = this.sections[i];
      if(!this.sectionAttentioned[i]){
        let top = section.getBoundingClientRect().top;
        if(top <= this.sh - (this.shh * .5)){
          this.sectionAttentioned[i] = true;

          //h2
          let items = section.querySelectorAll('h2 .item');
          let len2 = items.length;

          for( let j = 1; j < len2 - 1; j++ ){
            let item = items[j];
            let rotation = 30 + Math.random() * 30;
            if(Math.floor(Math.random() * 2) === 0) rotation *= -1;
            let delay = j * .04 + Math.random() * .02;
            this.commonTextMotion(item, delay, rotation, '-0.7rem');
          }
        }
      }
    }
  }

  scrollHandler() {
    this.scrollHero();
    this.scrollSection1();
    this.scrollSection2();
    this.scrollSection3();
    // this.checkPageBottom();
    this.check2NDView();
    this.scrollSections();
  }

  enterframe() {}

  enterframeThinOut() {
    // this.hero.enterframeThinOut();
  }

  executeResize() {
    super.executeResize();
    let scale, x, y;

    if(this.sw >= this.pack.BP){
      scale = this.sw / this.BASE_W_PC;
    }else{
      scale = this.sw / this.BASE_W_SP;
      scale = this.MASK_W_SP / this.MASK_W_PC * scale;
    }

    x = this.MASK_W_PC * -scale * .5;
    y = this.MASK_H_PC * -scale * .5;

    this.svgGroup.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
  }
}
